/*
 * File: /src/router/routes/assets.js
 * Created Date: Sunday July 5th 2020
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 5th July 2020 11:22:10 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2020 AdBase, Inc.
 */
const AssetsList = () =>
  import(/* webpackChunkName: "Assets" */ 'src/components/Dashboard/Views/Assets/AssetsList.vue');

export const assetsRoutes = [
  {
    path: 'assets/',
    name: 'Assets',
    component: AssetsList
  }
];
